import {createAsyncThunk} from '@reduxjs/toolkit'
import {getBookingStatusLink} from 'business/bofhLinks'
import {getCreateBookingResult} from 'modules/book/selectors'
import {getHttpRequestId} from 'modules/common/selectors'
import {getCurrentBookingRequestId} from 'utils/bookingRequestId'

import {bookApi} from '@vio/core/src/booking/services/bookApi'
import {LinkType} from '@vio/core/src/booking/types/Link'
import {getBovioApiKey} from '@vio/core/src/experiments/modules/selectors'

import type {BookingStatusPollingController} from '../bookingStatusPollingController'
import type {RootState} from 'store'

const POLLING_INTERVAL = 3000

export interface HandleBookingStatusPollingArg {
  shouldPoll: boolean
}

export const handleBookingStatusPolling = createAsyncThunk<
  void,
  HandleBookingStatusPollingArg,
  {
    state: RootState
    extra: {bookingStatusPollingController: BookingStatusPollingController}
  }
>(
  'bookingCreation/handleBookingStatusPolling',
  async ({shouldPoll}, {dispatch, getState, extra}) => {
    const {bookingStatusPollingController} = extra
    const state = getState()

    if (!shouldPoll) {
      bookingStatusPollingController.stop()
      return
    }

    const createBookingResult = getCreateBookingResult(state)

    const bookingStatusLink = getBookingStatusLink(
      createBookingResult.data?.links
    )
    if (!bookingStatusLink) return

    const subscription = dispatch(
      bookApi.endpoints.getBookingStatus.initiate(
        {
          link: bookingStatusLink as LinkType,
          profileKey: getBovioApiKey(state),
          httpRequestId: getHttpRequestId(state) ?? '',
          bookingRequestId: getCurrentBookingRequestId(),
          clientUserAgent: `checkout/${process.env.NEXT_PUBLIC_APP_VERSION}`
        },
        {
          subscriptionOptions: {
            pollingInterval: POLLING_INTERVAL
          }
        }
      )
    )
    bookingStatusPollingController.start(subscription)
  }
)
